import React, { useState } from "react";
import "../assets/css/Login.css";
import { FaEnvelope, FaLock } from "react-icons/fa";
import LoginPc from "../assets/images/computer.png";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";

const loginSchema = yup.object().shape({
  Username: yup.string().required("User Name Is Required"),
  Password: yup.string().required("Password Is Required"),
});

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    setErrorMessage("");

    try {
      const response = await axios.post(
        "https://vsoftapi.com-eg.net/api/ClientUsers/V6/Login",
        {
          ...data,
          RoleID: 2,
        },
        {
          headers: {
            CompanyID: "140111",
          },
        }
      );

      const resData = response.data;

      if (resData && (resData.AccessToken || resData.SessionID)) {
        // حفظ بيانات المستخدم في localStorage بشكل موحد لدعم الحالتين (الحروف الكبيرة والصغيرة)
        const normalizedUser = {
          success: true,
          Success: true,
          data: {
            ...resData,
            CompanyID: "140111",
          },
          Data: {
            ...resData,
            CompanyID: "140111",
          },
        };
        localStorage.setItem("userData", JSON.stringify(normalizedUser));
        navigate("/cs-home");
      } else {
        setErrorMessage(resData.message || resData.Message || "بيانات الدخول غير صحيحة");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        // إذا كان الحساب غير مصرح له أو منتهي
        if (error.response.status === 401) {
          localStorage.removeItem("userData");
        }
        setErrorMessage(errorData.message || errorData.Message || "بيانات الدخول غير صحيحة");
      } else {
        setErrorMessage("حدث خطأ أثناء الاتصال بالسيرفر");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-login">
      {loading ? (
        <div className="loading-screen">
          <CircularProgress size={80} sx={{ color: "#ef4b1f" }} />
        </div>
      ) : (
        <div className="login-container">
          <div className="login-card">
            <div className="login-image">
              <img src={LoginPc} alt="Login Illustration" />
            </div>
            <div className="login-form">
              <h2>{t("login")}</h2>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="input-group">
                  <FaEnvelope className="input-icon" />
                  <input
                    type="text"
                    placeholder={t("userName")}
                    {...register("Username")}
                  />
                  {errors.Username && (
                    <p className="error-message">{errors.Username.message}</p>
                  )}
                </div>
                <div className="input-group">
                  <FaLock className="input-icon" />
                  <input
                    type="password"
                    placeholder={t("password")}
                    {...register("Password")}
                  />
                  {errors.Password && (
                    <p className="error-message">{errors.Password.message}</p>
                  )}
                </div>


                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}
                <div className="input-group">
                  <button
                    type="submit"
                    className="login-button"
                    disabled={loading}
                  >
                    {t("login")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
